const { 
    update_button_visibility,
    clear_error,
    render_verify_error,
    register_verify_error_rederer,
    default_error_rederer    
} = require('./page_transition.js');

const {
    select_default,
    input_empty
} = require('./form_check_helper');

const nunjucks = require('nunjucks');

// ベリファイエラーレンダラーの追加
register_verify_error_rederer("verify-2a175167-2392-440d-9503-3f3d0b543397",default_error_rederer);
register_verify_error_rederer("verify-5f4a4921-8544-4757-be5a-ceb8cd0aab82",default_error_rederer);
register_verify_error_rederer("verify-f0f25396-dde7-448b-bc67-9fa09d9561ef",default_error_rederer);

const page2_verify=(application_context)=>{
    let DOM_select_category;

    application_context.ary_verify_error ??= [];

    // check1
    DOM_select_category = document.querySelector(`[data-page="2"] [name="category"]`);
    if(DOM_select_category === null) {
        // 内部エラー時もfalseを返す
        return false;
    }

    if(select_default(DOM_select_category)){
        application_context.ary_verify_error.push({
            code:"verify-2a175167-2392-440d-9503-3f3d0b543397",
            data:{
                field_name:"category",
                description:`参加区分を選択ください`
            }
        });
    }


    // check2
    DOM_select_voice_type = document.querySelector(`[data-page="2"] [name="voice_type"]`);
    if(DOM_select_voice_type === null) {
        // 内部エラー時もfalseを返す
        return false;
    }

    if(select_default(DOM_select_voice_type)){
        application_context.ary_verify_error.push({
            code:"verify-5f4a4921-8544-4757-be5a-ceb8cd0aab82",
            data:{
                field_name:"voice_type",
                description:`声種を選択ください`
            }
        });
    }

    // check3
    DOM_textarea_career = document.querySelector(`[data-page="2"] [name="career"]`);
    if(DOM_textarea_career === null) {
        // 内部エラー時もfalseを返す
        return false;
    }

    if(input_empty(DOM_textarea_career)){
        application_context.ary_verify_error.push({
            code:"verify-f0f25396-dde7-448b-bc67-9fa09d9561ef",
            data:{
                field_name:"career",
                description:`簡単経歴を入力ください`
            }
        });
    }
    return (application_context.ary_verify_error.length === 0);
}

module.exports.page2_prev = (application_context)=>{
    let page;

    window.splide_instance.go("<");

    page = window.splide_instance.index;
    application_context.page = page;

    update_button_visibility(application_context);    
}


module.exports.page2_next = (application_context)=>{

    // 次に進むタイミングでベリファイエラーをリセットする。
    application_context.ary_verify_error.length=0;
    clear_error({page:2});

    if(page2_verify(application_context)){
        let page;

        window.splide_instance.go(">");

        page = window.splide_instance.index;
        application_context.page = page;
        
        update_button_visibility(application_context);
    } else {
        for(let blob_verify_error of application_context.ary_verify_error){
            render_verify_error(blob_verify_error);
        }
    }
}
